/** Safe handling of the ?next= redirect target. */

/** Control characters and whitespace. Browsers strip these before parsing a URL, */
const CONTROL_OR_SPACE = /[\u0000-\u0020\u007f]/

/** True only for a same-origin path we are willing to send someone to. */
export function isSafeInternalPath(value: string | null | undefined): value is string {
  if (!value) return false
  if (!value.startsWith('/')) return false
  if (value.startsWith('//') || value.startsWith('/\\')) return false
  if (CONTROL_OR_SPACE.test(value)) return false
  if (/^\/+[a-z][a-z0-9+.-]*:/i.test(value)) return false
  return true
}

/** The validated `next`, or the given fallback. */
export function safeNext(value: string | null | undefined, fallback = '/'): string {
  return isSafeInternalPath(value) ? value : fallback
}

/** Build "/login?next=<current>" without losing the query string or hash. */
export function loginUrlFor(location: { pathname: string; search: string; hash: string }): string {
  const current = `${location.pathname}${location.search}${location.hash}`
  if (current === '/login' || current.startsWith('/login?')) return '/login'
  return `/login?next=${encodeURIComponent(current)}`
}
